export default "__VITE_ASSET__Js5NV6XQ__"